export default __webpack_public_path__ + "static/media/landing-hustle.e61434ff.webp";